import React, { useEffect, useMemo, useState } from 'react';
import SocialLink from './SocialLink';
import { collection, getDocs } from 'firebase/firestore';  // Import Firestore methods
import { database } from './firebase';  // Import the Firestore instance
import '../styles/SocialLinks.css';
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'

library.add(fab)
library.add(fas)

const FALLBACK_LINKS = [
  { id: 'github', title: 'GitHub', link: 'https://github.com/ipavlidakis', icon: ['fab', 'github'] },
  { id: 'linkedin', title: 'LinkedIn', link: 'https://www.linkedin.com/in/ipavlidakis/', icon: ['fab', 'linkedin'] },
  { id: 'x', title: 'X', link: 'https://x.com/ipavlidakis', icon: ['fab', 'x-twitter'] },
  { id: 'email', title: 'Email', link: 'mailto:hello@ipavlidakis.dev', icon: ['fas', 'envelope'] },
];

const SocialLinks = ({ variant = 'section', limit, activeSection }) => {
  const [socialLinks, setSocialLinks] = useState([]);
  const [status, setStatus] = useState('loading');

  // Fetch data from your backend using the `databases.listDocuments` method
  useEffect(() => {
    const fetchSocialLinks = async () => {
      try {
        setStatus('loading');
        const querySnapshot = await getDocs(collection(database, "social_links"));
        const links = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setSocialLinks(links.sort((a, b) => a.order - b.order));
        setStatus('ready');
      } catch (error) {
        console.error("Error fetching social links:", error);
        setStatus('error');
      }
    };

    fetchSocialLinks();
  }, []);

  const visibleLinks = useMemo(() => {
    const base = socialLinks.length > 0 ? socialLinks : (status === 'error' ? FALLBACK_LINKS : []);
    if (typeof limit === 'number') return base.slice(0, Math.max(0, limit));
    return base;
  }, [limit, socialLinks, status]);

  return (
    <div className={`social-links ${variant === 'hero' ? 'is-hero' : ''}`}>
      {variant === 'hero' ? null : <h2>Connect</h2>}
      <div className="social-links-container">
        {visibleLinks.length > 0 ? (
          visibleLinks.map((socialLink, index) => (
            <SocialLink
              key={socialLink.id}
              variant={variant}
              activeSection={activeSection}
              id={socialLink.id}
              position={index}
              icon={socialLink.icon}
              imageUrl={socialLink.image}
              title={socialLink.title}
              link={socialLink.link}
              backgroundColor={socialLink.background_color}
            />
          ))
        ) : status === 'loading' ? (
          variant === 'hero' ? null : <p>Loading social links...</p>
        ) : (
          variant === 'hero' ? null : <p>Could not load social links.</p>
        )}
      </div>
    </div>
  );
};

export default SocialLinks;
